












import Vue from "vue";

import VUpdateStringsForm from "@/components/inventoryComponents/strings/layout/VUpdateStringsForm.vue";

export default Vue.extend({
  name: "VUseStrings",
  components: { VUpdateStringsForm },
  props: {
    strings: {
      type: Array,
      required: true
    }
  }
});
